import React, { useContext, useEffect, useState } from 'react';

import { getExistingContent } from '@/api/lists';
import { ListContext } from '@/context/ListContext';

const LegacyUseExisingModal = ({hideModal, appGuid, listId}: {hideModal:any, appGuid:string, listId:string}) => {

    const [existingContent, setExistingContent] = useState<any>()
    const {isMainMenu} = useContext(ListContext)

    useEffect(() => {
        getExistingContent(appGuid, listId, isMainMenu ? 'end' : 'start').then((data) => setExistingContent(data))
    }, [])

    return (
        <div dangerouslySetInnerHTML={{__html: existingContent}} />
    )
}
export default LegacyUseExisingModal